<template>
  <div class="ui form" ref="form">
    <div class="field">
      <label for="">{{ $t("logo") }}</label>
      <file-pond
        name="bill_file"
        ref="file"
        :label-idle="$t('click or drop files here')"
        v-bind:allow-multiple="false"
        v-bind:allow-revert="false"
        v-bind:server="{
          url: api_host,
          timeout: enterprise_setup.upload_timeout,
          process: {
            url: '/nvidia_bundle/store/do-upload-logo',
            method: 'POST',
            headers: {
              'x-access-token': token_session,
            },
            withCredentials: false,
          },
        }"
        v-on:error="filepond_error"
        v-on:processfile="filepond_process"
      />
    </div>
    <div class="field" v-show="logo && logo.relative_path">
      <label for="">{{ $t("preview") }}</label>
      <img
        class="ui centered medium image"
        :src="api_host + '/' + logo.relative_path"
      />
      <!-- <div class="ui small image">
        <image
          class="ui medium image"
          :src="api_host + '/' + logo.relative_path"
        ></image>
      </div> -->
    </div>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import {
  /* local_api, error_toast, */ enterprise_setup,
  api_host,
} from "@/utils";
import filters from "@/filters";

export default {
  name: "NvidiaBundleStoreModalGeneral",
  filters: filters,
  components: {},
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          country: ["empty"],
        },
      });
    },
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: {},
  data() {
    return {
      logo: "",
      api_host: api_host,
    };
  },
  methods: {
    setData(setup) {
      // let vm = this;
      // vm.setup = setup;
      console.log(setup);
      this.logo = setup.logo;
    },
    getData() {
      return this.logo;
    },
    isValid() {
      return this.form.form("validate form");
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) this.$alertify.error(r.error);
        else this.logo = r.data;
      }
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
